module.exports = __webpack_public_path__ + "img/flecha-enter.3a5ff341.svg";